import { render, staticRenderFns } from "./NewsWidget.vue?vue&type=template&id=25599a5c&scoped=true&"
import script from "./NewsWidget.vue?vue&type=script&lang=js&"
export * from "./NewsWidget.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/NewsWidget.css?vue&type=style&index=0&id=25599a5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25599a5c",
  null
  
)

export default component.exports